import { FieldProps } from 'formik'
import React from 'react'

import Select from '@/components/select/Select'
import useAppSelector from '@/hooks/useAppSelector'
import { selectFcaServiceAreas } from '@/redux/slices/commonData'

interface Props extends FieldProps {
  className: string
}

const SelectFcaServiceAreaField: React.FC<Props> = ({
  field,
  form,
  className,
}) => {
  const serviceAreas = useAppSelector(selectFcaServiceAreas)

  const options = serviceAreas.map((serviceArea) => ({
    value: serviceArea,
    label: serviceArea.name,
  }))

  return (
    <Select
      className={className}
      options={options}
      name={field.name}
      value={options.find(
        (option) => field.value && option.value['@id'] === field.value['@id'],
      )}
      onChange={(option) => form.setFieldValue(field.name, option?.value)}
      onBlur={field.onBlur}
    />
  )
}

export default SelectFcaServiceAreaField
